import clsx from "clsx";

/**
 * Cosmetic claim axis types per cosmetic_claim_proof_matrix.axis column.
 * Each gets a distinct color so users can scan claim lists visually:
 * Claim/Mechanism/Application/Technical/Trend/Regulatory_Origin/Comparison/Brand_Entity.
 */
// Farb-Ausnahme (dokumentiert): jede Achse bekommt bewusst eine EIGENE
// kategoriale Farbe (purple/green/teal/pink/amber), damit Claim-Listen visuell
// scanbar sind. Das ist KEINE Ampel-Status-Kodierung — deshalb bleiben die
// rohen Paletten-Farben hier absichtlich stehen (Status-Tokens würden die
// Unterscheidung kollabieren).
const AXIS_STYLES: Record<string, { color: string; tip: string }> = {
  Claim:             { color: "bg-accent-100 text-accent-800",
                       tip: "Marketing-sicherer Wirk-Claim" },
  Mechanism:         { color: "bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300",
                       tip: "Wie es wirkt (molekularer/biologischer Mechanismus)" },
  Application:       { color: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
                       tip: "Anwendung (in Produkttyp X)" },
  Technical:         { color: "bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300",
                       tip: "Formulierungs-technische Aspekte" },
  Trend:             { color: "bg-pink-100 text-pink-800 dark:bg-pink-900/40 dark:text-pink-300",
                       tip: "Markt-/Verbraucher-Trend" },
  Regulatory_Origin: { color: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
                       tip: "Regulatorik oder Natürlichkeits-Nachweis" },
  Comparison:        { color: "bg-accent-100 text-accent-800",
                       tip: "Vergleich mit anderen Wirkstoffen" },
  Brand_Entity:      { color: "bg-surface-3 text-text",
                       tip: "Marken-Entität / Identitäts-Claim" },
};

const DEFAULT = { color: "bg-cream-200 text-ink dark:bg-ink-700", tip: "" };

export function AxisBadge({ axis, size = "xs" }: { axis: string | null; size?: "xs" | "sm" }) {
  if (!axis) return null;
  const style = AXIS_STYLES[axis] ?? DEFAULT;
  const sz = size === "sm" ? "text-xs px-2 py-0.5" : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      className={clsx("rounded-md font-medium uppercase tracking-wide", style.color, sz)}
      title={style.tip || axis}
    >
      {axis.replace(/_/g, " ")}
    </span>
  );
}
